import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ArrowRight from "@material-ui/icons/KeyboardArrowRight";
import MenuIcon from "@material-ui/icons/Menu";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import { Fragment, KeyboardEvent, useEffect, useState } from "react";
import { ROUTES, WORDPRESS_URL } from "../../constants";
import * as goMoLogo from "../../static/img/GoMoLogo.png";
import { i18n } from "../../translations/i18n";
import { VariantButton } from "../variantButton/VariantButton";
import { VariantDivider } from "../variantDivider/VariantDivider";
import "./Header.scss";
import { NavigationDesktop, NavigationMobile } from "./headerNavigation";
import { changeLanguageAutomatic, fixUrlLanguage, getLanguage } from "@utils/changeLanguage";
import { useHistory } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

interface IProps {
    cartItemsNumber?: number;
    logoutCallback?(): void;
}

export const Header = (props: IProps) => {
    const { cartItemsNumber, logoutCallback } = props;
    const isDesktop = window.innerWidth >= 769;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { location, push } = useHistory();
    const [selectedLanguage, setSelectedLanguage] = useState("");

    useEffect(() => {
        var translatedLang = "GR";
        const lang = getLanguage();
        if (lang == "en") {
            translatedLang = "GB";
        }
        setSelectedLanguage(translatedLang);
    }, []);

    const setSelected = (code: string) => {
        setSelectedLanguage(code);
        push(changeLanguageAutomatic(code));
        window.location.reload();
    };

    const changeMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            if (keycloakUtils.isAuthenticated()) {
                logOut();
            } else {
                logIn();
            }
        }
    };

    const logIn = () => {
        keycloakUtils.login({
            redirectUri: `${window.location.origin}${location.pathname}`,
        });
    };

    const logOut = () => {
        if (logoutCallback) {
            logoutCallback();
        }

        keycloakUtils.logout({
            redirectUri: `${window.location.origin}`,
        });
    };

    return (
        <Fragment>
            <AppBar position="static">
                <Toolbar className="header-toolbar">
                    <div>
                        <a aria-label="home page" href={WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_HOME_URL_EN)}>
                            <img alt="gomo logo" className="header-toolbar__logo" src={goMoLogo} />
                        </a>
                    </div>
                    <div className="header-toolbar__links">
                        {isDesktop && (
                            <Fragment>
                                <NavigationDesktop />
                                <VariantButton
                                    backgroundColor="#fcd13a"
                                    backgroundColorHover="#fdc504"
                                    className="header-toolbar__links-myaccount"
                                    href={fixUrlLanguage(ROUTES.MYACCOUNT_URL_EN)}
                                    size="large"
                                    textColor="#4a148c"
                                    variant="contained"
                                >
                                    {i18n.t("MyGoMo")}
                                </VariantButton>
                            </Fragment>
                        )}
                        <div
                            className="header-toolbar__links-login"
                            role="button"
                            tabIndex={0}
                            onClick={keycloakUtils.isAuthenticated() ? logOut : logIn}
                            onKeyDown={handleKeyDown}
                        >
                            <Typography color="inherit" variant="body2">
                                {keycloakUtils.isAuthenticated() ? i18n.t("Logout") : i18n.t("Login")}
                            </Typography>
                            <ArrowRight className="header-toolbar__links-login" />
                        </div>
                        {location.pathname !== `${fixUrlLanguage(ROUTES.CONFIRMATION_PAGE_URL_EN)}` && (
                            <Fragment>
                                <VariantDivider />
                                <IconButton
                                    aria-label="cart"
                                    color="inherit"
                                    onClick={() => push(`${fixUrlLanguage(ROUTES.CART_PAGE_URL_EN)}`)}
                                >
                                    <Badge
                                        badgeContent={cartItemsNumber}
                                        color="secondary"
                                        invisible={!cartItemsNumber}
                                    >
                                        <ShoppingCart />
                                    </Badge>
                                </IconButton>
                            </Fragment>
                        )}
                        <>
                            <VariantDivider />
                            <ReactFlagsSelect
                                selected={selectedLanguage}
                                onSelect={(code) => setSelected(code)}
                                countries={["GR", "GB"]}
                                showOptionLabel={false}
                                className={"flags-selection"}
                                showSelectedLabel={false}
                            />
                        </>
                        {!isDesktop && (
                            <IconButton aria-label="Open drawer" color="inherit" onClick={changeMenu}>
                                <MenuIcon />
                            </IconButton>
                        )}
                    </div>
                </Toolbar>
            </AppBar>
            {isMenuOpen && (
                <div className="menu-list">
                    <NavigationMobile />
                </div>
            )}
        </Fragment>
    );
};
